// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-2bc","label":"styles_label__2-mF2"};